import { Table } from "antd";
import { ColumnsType } from "antd/lib/table";
import { Pencil, Trash2 } from "lucide-react";
import { Actions } from "../Actions/Actions";
import styles from "../styles.module.scss";
import {
  expendedPurchaseColumns,
  ExpendedPurchaseRow,
  getColor,
  PurchaseRow,
} from "./utils";

interface PurchaseTableProps {
  data: PurchaseRow[];
  onEdit: (purchase: PurchaseRow) => void;
  onDelete: (purchase: PurchaseRow) => void;
}

const PurchaseTable: React.FC<PurchaseTableProps> = ({
  data,
  onEdit,
  onDelete,
}) => {
  const purchaseColumns: ColumnsType<PurchaseRow> = [
    { title: "Purchase Order #", dataIndex: "poNumber", key: "po" },

    {
      title: "Status",
      dataIndex: "status",
      key: "status",
      render: (r) => <span style={{ color: getColor(r) }}>{r}</span>,
    },

    { title: "Income Terms", dataIndex: "incomeTerms", key: "terms" },
    { title: "PO Date", dataIndex: "poDate", key: "date" },
    {
      title: "Estimated Completion Date",
      dataIndex: "estCompletion",
      key: "est",
    },
    { title: "Actual Completion Date", dataIndex: "actCompletion", key: "act" },
    { title: "Destination", dataIndex: "destination", key: "dest" },
    {
      title: "Actions",
      key: "actions",
      width: 250,
      render: (_: unknown, row: PurchaseRow) => (
        <Actions
          record={row}
          actions={[
            {
              label: "send to supplier",
              onClick: (r) => console.log("Send", r),
            },
            {
              icon: <Pencil />,
              onClick: (r) => onEdit(r),
            },
            {
              icon: <Trash2 />,
              onClick: (r) => onDelete(r),
            },
          ]}
        />
      ),
    },
  ];

  const expandedRowRender = (record: PurchaseRow) => {
    return (
      <Table<ExpendedPurchaseRow>
        columns={expendedPurchaseColumns}
        dataSource={record.products}
        pagination={false}
        rowKey="asin"
      />
    );
  };

  return (
    <Table
      columns={purchaseColumns}
      dataSource={data}
      expandable={{ expandedRowRender }}
      pagination={{ pageSize: 10 }}
      rowKey="key"
      className={styles.table}
    />
  );
};

export default PurchaseTable;
